module.exports = __webpack_public_path__ + "42534ed579e85672a50b2a4695dc2baa.pdf";